<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="71"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
  </div>
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  @if (!isLoading) {
    <div class="col-md-10 offset-md-1 ziro-report-content">
      <div
        class="alert"
        [ngClass]="{ 'alert-info': !errorAlert, 'alert-danger': errorAlert }"
        data-automation="pstn-calling-usage-info"
      >
        <div
          [innerHTML]="
            errorAlert
              ? (errorAlert | escapeHtml)
              : ('tkey;reports.microsoft.teams_pstn_calling_usage.info_box.text' | escapeHtml: infoBoxParams)
          "
        ></div>
      </div>
      <ziro-datatable
        #datatable
        [isCondensed]="true"
        [columns]="datatableCols"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'user'"
        [mainFilterPlaceholder]="'tkey;reports.microsoft.teams_pstn_calling_usage.search.placeholder' | translate"
        [maxLength]="150"
        [dataAutomation]="tableDataAutomation"
        [matchesSecondaryDataFn]="matchesSecondaryDataFn"
        [stickyColumnCount]="1"
        [isColumnVisibilityFilterVisible]="true"
        [columnVisibilityFilterOptions]="columnVisibilityFilterOptions"
        [columnVisibilityFilterInitialOptions]="defaultVisibleColumns"
        (searchResultsChanged)="onTableResultsChanged()"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.teams_pstn_calling_usage.account_type.label'"
          [items]="accountTypeFilterOptions"
          [matchFn]="isAccountTypeMatch"
          [dataAutomation]="'account-type-filter'"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.teams_pstn_calling_usage.filter.suggested_calling_product.label'"
          [items]="suggestedCallingProductFilterOptions"
          [matchFn]="suggestCallingProductFilterMatch"
          [dataAutomation]="'suggested-calling-product-filter'"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.teams_pstn_calling_usage.suggested_changes.label'"
          [items]="suggestedChangesFilterOptions"
          [matchFn]="isSuggestedChangesMatch"
          [dataAutomation]="'suggested-changes-filter'"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.teams_pstn_calling_usage.pstn_type.label'"
          [items]="pstnTypeFilterOptions"
          [matchFn]="pstnTypeMatch"
          [dataAutomation]="'pstn-type-filter'"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.teams_pstn_calling_usage.calling_plan.label'"
          [items]="callingPlanFilterOptions"
          [matchFn]="callingPlanMatch"
          [dataAutomation]="'calling-plan-filter'"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    </div>
  }
</div>
<ziro-bottom-nav></ziro-bottom-nav>
